/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import get from "lodash/get";
import { componentMetadata } from "../server/component-list";
import { addAssociatedMetadata } from "./utils";

const getCollectionBySlug = async slug => {
  const collectionData = await (await fetch(`/api/v1/collections/${slug}`)).json();
  return collectionData;
};

const getDefaultStoriesCount = layoutName => {
  for (const component of componentMetadata) {
    const { componentName, storiesCount } = component;
    if (layoutName === componentName) return storiesCount;
  }
};

const getChildCollectionData = async collection =>
  Promise.all(
    collection.items
      .filter(collectionItem => collectionItem.type === "collection")
      .map(collectionItem => (collectionItem.slug ? getCollectionBySlug(collectionItem.slug) : collectionItem))
  );

const updatedStoriesAndCollectionPageData = async (rows, collection) => {
  const initialCollections = new Array(rows.length).fill({});
  const collectionItems = collection.items.filter(collectionItem => collectionItem.type === "collection");
  const storyItems = collection.items.filter(collectionItem => collectionItem.type === "story");
  const collectionsCache = {};
  for (const index in rows) {
    const row = rows[index];
    const { config = {}, layout } = row;
    // const storiesCount = getDefaultStoriesCount(layout);
    config.initialLoadCount = parseInt(config.initialLoadCount);
    switch (config.dataType) {
      case "collection":
        const childCollectionStories = get(collectionItems, [0, "items"], []).filter(item => item.type === "story");
        if (collectionItems.length > 0) {
          const currentRowCollectionData = {
            ...collectionItems[0],
            items: childCollectionStories,
            "associated-metadata": row
          };
          initialCollections[index] = currentRowCollectionData;
        }
        break;
      case "collectionWithSlug":
        if (!collectionsCache[config.slug]) {
          collectionsCache[config.slug] = { collectionInfo: {} };
          // copy collection info
          const collectionInfo = {};
          const collectionSlugData = await getCollectionBySlug(config.slug);
          for (const key in collectionSlugData) {
            if (key !== "items") collectionInfo[key] = collectionSlugData[key];
          }
          const getCollectionItems = await getChildCollectionData(collectionSlugData);
          const getStoryItems = collectionSlugData.items.filter(collectionItem => collectionItem.type === "story");
          collectionsCache[config.slug] = {
            collectionInfo,
            stories: { items: getStoryItems },
            collections: { items: getCollectionItems }
          };
        }
        if (collectionsCache[config.slug].stories.items.length > 0) {
          const storiesFromCache = collectionsCache[config.slug].stories.items;
          const currentRowCollectionData = {
            ...collectionsCache[config.slug]["collectionInfo"],
            type: "collection",
            items: storiesFromCache,
            "associated-metadata": row
          };
          initialCollections[index] = { ...currentRowCollectionData, type: "collection", "associated-metadata": row };
        }
        break;
      default:
        if (storyItems.length > 0) {
          const currentRowCollectionData = {
            ...collection,
            type: "collection",
            items: storyItems,
            "associated-metadata": row
          };
          initialCollections[index] = currentRowCollectionData;
        }
    }
  }
  return { type: "collection", items: initialCollections };
};

export async function overrideLayoutsForSection(config, collection) {
  const pageConfig = get(config, ["pagebuilder-config", "section"]);
  const layouts = get(
    config,
    ["pagebuilder-config", "section", "rows"],
    get(config, ["theme-attributes", "override_layouts"])
  );
  if (!layouts) {
    return collection;
  }

  try {
    // TODO: Remove the pageConfig.layoutDataType fallback once all publishers have moved to `pageSetting.layoutDataType`
    // Mostly this fallback can safely deleted after 30th June, 2020 as no prod publishers have this structure.
    const layoutDataType = get(pageConfig, ["pageSetting", "layoutDataType"], pageConfig.layoutDataType);
    if (layoutDataType === "storiesAndCollections") {
      return updatedStoriesAndCollectionPageData(layouts, collection);
    }
  } catch (error) {
    return collection;
  }
  return addAssociatedMetadata(collection, layouts); // layoutDatatype === "collections"
}
